module.exports = {"350723100":"杭川镇","350723101":"寨里镇","350723102":"止马镇","350723200":"鸾风乡","350723201":"崇仁乡","350723202":"李坊乡","350723203":"华桥乡","350723204":"司前乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350723.json
// module id = 1127
// module chunks = 0